import React from "react";

import Table from "../common/Table";
import Option from "../common/RowOption";

import lbl from "../../data/Labels.json";

const FinancePaymentsList = ({ activeYear }) => {
  const paymentsColumn = [
    { path: "id", label: "شماره" },
    { path: "payment_date", label: "تاریخ" },
    {
      path: "attachment",
      label: "سند",
      content: ({ attachment }) =>
        attachment && (
          <a href={attachment} download target="_blank">
            {lbl.Download}
          </a>
        ),
    },
    { path: "paid_by_staff_name", label: "پرداخت کننده" },
    { path: "modified_by_staff_name", label: "ثبت کننده" },
    { path: "remark", label: "ملاحظه" },
    { path: "amount", label: "مبلغ" },
    { path: "bank_ref_no", label: "ریفرنس نمبر" },
    {
      path: "option",
      content: (e) => (
        <Option
          Edit={{ form: "teacher-payment-form", cache: e.teacher_id, edit: e }}
          Delete={{ route: "teachers/payment", id: e.id }}
          Print={{ route: `teacher-salary-receipt/${e.teacher_id}/${e.id}`}}
        />
      ),
    },
  ];

  return (
    <div className="table-card">
      <p className="table-title">{lbl.Payments}</p>
      <Table
        data={activeYear?.payments}
        columns={paymentsColumn}
        total={activeYear?.paid}
      />
    </div>
  );
};

export default FinancePaymentsList;
